<header class="d-flex justify-content-between px-3 bg-white align-items-center shadow">
  <div>
    <img src="assets/allianz.png" width="170px" height="auto">
  </div>
<!--  <div class="header-translate color-light-blue px-3 py-1">-->
<!--    English <i class="bi-chevron-down"></i>-->
<!--  </div>-->
</header>
